import {useMemo, useState, useRef} from 'react';
import {Tooltip, useSmartPosition} from '@flixbus/honeycomb-react';
import {countriesList} from '../../constant/countriesList';
import {CountryCodesWithTooltipProps} from './CountryCodesWithTooltip.types';

const CountryCodesWithTooltip: React.FC<CountryCodesWithTooltipProps> = ({
  codes
}) => {
  const tooltipInnerRef = useRef(null);
  const tooltipBalloonRef = useRef(null);
  const [isActive, setIsActive] = useState(false);

  const tooltipContent = useMemo(() => {
    const sortedCodes = [...codes].sort();
    return sortedCodes
      .map(code => {
        const country = countriesList.find(c => c.country_code === code);
        return country ? `${country.name} (${code})` : code;
      })
      .join('\n');
  }, [codes]);

  const [smartPosition, smartAlignment] = useSmartPosition({
    active: isActive,
    targetRef: tooltipInnerRef,
    elementRef: tooltipBalloonRef,
    smartPositionAllowedPositions: ['top', 'bottom'],
    position: 'right',
    alignment: 'start'
  });

  return (
    <Tooltip
      innerRef={tooltipInnerRef}
      balloonRef={tooltipBalloonRef}
      id="country-codes-tooltip"
      content={
        <div style={{whiteSpace: 'pre-line', textAlign: 'left'}}>
          {tooltipContent}
        </div>
      }
      position={smartPosition}
      alignment={smartAlignment}
      active={isActive}
    >
      <span
        onMouseEnter={() => setIsActive(true)}
        onMouseLeave={() => setIsActive(false)}
      >
        {[...codes].sort().join(', ')}
      </span>
    </Tooltip>
  );
};

export default CountryCodesWithTooltip;
